const BANK_DETAILS = [
  {
    id: 27,
    name: "Allahabad Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 6,
    name: "Andhra Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: ""
  },
  {
    id: 4,
    name: "Axis Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^[a-zA-Z0-9]{2,30}$"
  },
  {
    id: 17,
    name: "Bank of Baroda",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: "^(?!.*\\..*\\.)[A-Za-z0-9.]{1,65}$"
  },
  {
    id: 15,
    name: "Bank of India",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 8,
    name: "Canara Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^(?!.*(.)(?:.*?\\1){5})[A-z0-9]{4,14}$"
  },
  {
    id: 21,
    name: "Corporation Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: ""
  },
  {
    id: 42,
    name: "Dbs Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 19,
    name: "Dena Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 13,
    name: "Federal Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^[A-Za-z0-9 ._@#*$&+%!^-]{1,65}$"
  },
  {
    id: 1,
    name: "HDFC Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^(?![@._])(?!.*[_.@]{2})[\\w.@]{5,15}(?<![@._])$"
  },
  {
    id: 3,
    name: "ICICI Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: ""
  },
  {
    id: 7,
    name: "IDBI Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^[^\\s]{1,65}$"
  },
  {
    id: 29,
    name: "IDFC FIRST Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: "^[6-9]\\d{9}$"
  },
  {
    id: 12,
    name: "Indian Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^[A-z0-9]{5,15}$"
  },
  {
    id: 30,
    name: "Indian Overseas Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 26,
    name: "IndusInd Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: ""
  },
  {
    id: 28,
    name: "Karnataka Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^[^\\s]{1,65}$"
  },
  {
    id: 32,
    name: "Karur Vysya Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 5,
    name: "Kotak Mahindra Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^[a-zA-Z0-9]{3,35}$"
  },
  {
    id: 22,
    name: "Oriental Bank of Commerce",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 9,
    name: "Punjab National Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: "^[A-z0-9._]{6,28}$"
  },
  {
    id: 36,
    name: "RBL (Ratnakar) Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 25,
    name: "Standard Chartered Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: "^[^\\s]{1,16}$"
  },
  {
    id: 2,
    name: "State Bank of India",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^(?![-._])(?!.*[_.-]{2})[\\w.-]{3,20}(?<![-._])$"
  },
  {
    id: 24,
    name: "Syndicate Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 34,
    name: "UCO Bank",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^[^.]*$"
  },
  {
    id: 16,
    name: "Union Bank of India",
    inst_type: "Bank",
    form26as_enabled: true,
    username_regex: "^[^\\s]{4,65}$"
  },
  {
    id: 23,
    name: "United Bank of India",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 20,
    name: "Vijaya Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: ""
  },
  {
    id: 11,
    name: "Yes Bank",
    inst_type: "Bank",
    form26as_enabled: false,
    username_regex: "^[A-Za-z0-9]{6,20}$"
  }
];

export default BANK_DETAILS; 